import { render, staticRenderFns } from "./MyPointCard.vue?vue&type=template&id=7c181791&scoped=true"
import script from "./MyPointCard.vue?vue&type=script&lang=js"
export * from "./MyPointCard.vue?vue&type=script&lang=js"
import style0 from "./MyPointCard.vue?vue&type=style&index=0&id=7c181791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c181791",
  null
  
)

export default component.exports